module.exports = __webpack_public_path__ + "media/audios/parent/lesson_3/audio5-be1aea5b700f790402316ade20b5ca7f.m4a";